import '../../styles/button.css';

import { ButtonMode, ButtonSize } from '../../types';
import { ButtonSizes, ButtonTypes } from '../../consts/button';

export interface ButtonProps {
  /**
   * Button mode
   */
  mode?: ButtonMode;
  /**
   * Button size
   */
  size?: ButtonSize;
  /**
   * Button type
   */
  type?: 'button' | 'submit' | 'reset';
  /**
   * Button label
   */
  label: string;
  /**
   * Button class name
   */
  className?: string;
  /**
   * Icon right
   */
  iconRight?: {
    /**
     * Image src
     */
    src: string;
    /**
     * Image alt text
     */
    alt?: string;
  };
  /**
   * Action to be performed on click
   */
  onClick?: () => void;
  /**
   * Indicates whether the button should be disabled
   */
  disabled?: boolean;
}

export const Button = (
  {
    mode = ButtonTypes.PRIMARY,
    size = ButtonSizes.MEDIUM,
    label,
    type = 'button',
    className,
    iconRight,
    onClick,
    disabled,
  }: ButtonProps,
) => (
  <button
    type={type}
    className={`${mode} ${size} ${className || ''} ${iconRight ? 'icon-right' : ''}`}
    onClick={onClick}
    disabled={disabled}
  >
    {label}
    {!!iconRight?.src && <img alt="" {...iconRight} />}
  </button>
);
